var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"styel":"margin-left:10 rem;"}},[_c('iframe',{attrs:{"frameborder":"0","width":"100%","height":"1000","src":"https://analytics.zoho.com/open-view/1403135000010165815/f7b823a771f02e6bf0247061b2c25cf3"}})])
}]

export { render, staticRenderFns }